const px = (n: number) => `${n}px`;

export const scaledPx = (factor: number) => (value: number) => px(value * factor);

export default px;
